/**
 * Reports DataTables 列 index → バックエンド report.service の hierarchy キー。
 * 列 1・2 は保管場所/保管庫で storage_room を共有。
 */
export const REPORT_HIERARCHY_KEY_ORDER = [
  'creator',
  'storage_room',
  'drawer',
  'case',
  'bsl_level',
  'pathogen_genus',
  'pathogen_species',
  'pathogen_subspecies',
  'pathogen_strain',
  'type',
  'sample_name',
  'notes',
] as const;

export type ReportHierarchyKey = (typeof REPORT_HIERARCHY_KEY_ORDER)[number];

/** 列 index → hierarchy キー（null は集計軸に含めない） */
export const REPORT_COLUMN_TO_HIERARCHY: Record<number, ReportHierarchyKey | null> = {
  0: 'creator',
  1: 'storage_room',
  2: 'storage_room',
  3: 'drawer',
  4: 'case',
  5: 'bsl_level',
  6: 'pathogen_genus',
  7: 'pathogen_species',
  8: 'pathogen_subspecies',
  9: 'pathogen_strain',
  10: 'type',
  11: 'sample_name',
  12: 'notes',
  13: null,
};

/** 表示中の列から API に送る hierarchy 配列を組み立てる */
export function buildReportHierarchyFromVisibleColumns(
  isColumnVisible: (columnIndex: number) => boolean
): string[] {
  const activeKeys = new Set<string>();
  for (const [indexStr, key] of Object.entries(REPORT_COLUMN_TO_HIERARCHY)) {
    if (!key) continue;
    const index = Number(indexStr);
    if (isColumnVisible(index)) {
      activeKeys.add(key);
    }
  }
  return REPORT_HIERARCHY_KEY_ORDER.filter((key) => activeKeys.has(key));
}
